import { createSelector } from 'reselect';
import PredesComplianceIncorrectLocationCodeUsageSummaryColumns
  from '../../containers/PredesComplianceIncorrectLocationCodeUsageSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceIncorrectLocationCodeUsageSummaryColumns);
